<template>
    <div class="overflow-x-auto">
        <table class="table-auto border-collapse border border-gray-300 w-full text-sm">
            <thead>
                <tr>
                    <th
                        v-for="header in displayedHeaders"
                        :key="header.id"
                        class="border border-gray-300 px-4 py-2 bg-gray-100 text-left column-width"
                    >
                        {{ header.name }}
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(row, index) in tableRows" :key="index">
                    <td
                        v-for="header in displayedHeaders"
                        :key="header.id"
                        class="border border-gray-300 px-4 py-2 text-center column-width"
                    >
                        {{ row[header.name] }}
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    name: "AdminSurveyTable",
    props: {
        headers: {
            type: Array,
            required: true,
        },
        rowData: {
            type: Object,
            required: true,
        },
        selectedHeaders: {
            type: Array,
            required: true,
        },
    },
    computed: {
        displayedHeaders() {
            if (this.selectedHeaders.length === 0) {
                return this.headers;
            }
            const selectedHeaderNames = this.selectedHeaders.map((header) => header.name);
            return this.headers.filter((header) =>
                selectedHeaderNames.includes(header.name)
            );
        },
        tableRows() {
            const rows = [];
            const rowCount = Object.values(this.rowData)[0]?.length || 0;
            for (let i = 0; i < rowCount; i++) {
                const row = {};
                this.displayedHeaders.forEach((header) => {
                    const headerName = header.name; // 헤더의 name 속성
                    row[headerName] = this.rowData[headerName]?.[i] || "";
                });
                rows.push(row);
            }
            return rows;
        },
    },
};
</script>

<style scoped>
.table-auto {
    border-spacing: 0;
}

.column-width {
    width: 120px; /* 각 열의 너비 */
    min-width: 120px;
}
</style>
